"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.UploadFileResponseDtoMimeTypeEnum = void 0;
exports.instanceOfUploadFileResponseDto = instanceOfUploadFileResponseDto;
exports.UploadFileResponseDtoFromJSON = UploadFileResponseDtoFromJSON;
exports.UploadFileResponseDtoFromJSONTyped = UploadFileResponseDtoFromJSONTyped;
exports.UploadFileResponseDtoToJSON = UploadFileResponseDtoToJSON;
exports.UploadFileResponseDtoToJSONTyped = UploadFileResponseDtoToJSONTyped;
/**
 * @export
 */
exports.UploadFileResponseDtoMimeTypeEnum = {
    ImageJpeg: 'image/jpeg',
    ImagePng: 'image/png',
    ImageWebp: 'image/webp',
    ImageGif: 'image/gif',
    ApplicationPdf: 'application/pdf'
};
/**
 * Check if a given object implements the UploadFileResponseDto interface.
 */
function instanceOfUploadFileResponseDto(value) {
    if (!('url' in value) || value['url'] === undefined)
        return false;
    if (!('mimeType' in value) || value['mimeType'] === undefined)
        return false;
    if (!('name' in value) || value['name'] === undefined)
        return false;
    return true;
}
function UploadFileResponseDtoFromJSON(json) {
    return UploadFileResponseDtoFromJSONTyped(json, false);
}
function UploadFileResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'url': json['url'],
        'mimeType': json['mimeType'],
        'name': json['name'],
    };
}
function UploadFileResponseDtoToJSON(json) {
    return UploadFileResponseDtoToJSONTyped(json, false);
}
function UploadFileResponseDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'url': value['url'],
        'mimeType': value['mimeType'],
        'name': value['name'],
    };
}
//# sourceMappingURL=UploadFileResponseDto.js.map